import React from 'react';
import { Droppable, Draggable } from '@hello-pangea/dnd';
import InProgressCard from './InProgressCard';
import { getInProgressStageCountLabel } from '@/modules/deals/utils';

const InProgressColumn = ({ stage, deals, onCardClick, onOpenClient, onOpenStaff, staff = [] }) => {
  return (
    <section className="deals-column">
      <div className="deals-column__header">
        <h3 className="deals-column__title">{stage}</h3>
        <p className="deals-column__count">{getInProgressStageCountLabel(deals.length)}</p>
      </div>

      <Droppable droppableId={stage}>
        {(provided, snapshot) => (
          <div
            ref={provided.innerRef}
            {...provided.droppableProps}
            className={snapshot.isDraggingOver ? 'deals-column__body is-over' : 'deals-column__body'}
          >
            {deals.map((deal, index) => (
              <Draggable key={deal.id} draggableId={String(deal.id)} index={index}>
                {(providedDraggable, snapshotDraggable) => (
                  <InProgressCard
                    deal={deal}
                    onClick={onCardClick}
                    onOpenClient={onOpenClient}
                    onOpenStaff={onOpenStaff}
                    staff={staff}
                    provided={providedDraggable}
                    snapshot={snapshotDraggable}
                  />
                )}
              </Draggable>
            ))}

            {provided.placeholder}

            {deals.length === 0 && !snapshot.isDraggingOver && (
              <div className="deals-column__empty">Nessun affare in questa fase</div>
            )}
          </div>
        )}
      </Droppable>
    </section>
  );
};

export default InProgressColumn;
